import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
export default function Selectrow( {selectRow,handleRowSelect,postPerPage,data,dataValues} ) {
    return (
        <div>
            <FormControl className='selected-control' variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label"> {postPerPage < data.length ? postPerPage : data.length} Rows</InputLabel>
                <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={selectRow}
                    onChange={handleRowSelect}
                    label="Rows"
                >
                    {dataValues.map((values,idx) => (
                        <MenuItem key = {idx} value = {values}> {values} </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}
